import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Observable} from 'rxjs';
import { UtilService } from 'src/app/service/util';
import { CabecalhoRomaneio, CabecalhoRomaneioCliente, Dano, DanosLista, ExpedicaoRomaneioItemDto, ExpedicaoRomaneioItemPedidoDto, FiltroUR, PedidoItemExpedicaoDto, PedidoItemExpedicaoDtoLista, PedidoLote, ProgramacaoCarregamentoItems, ProgramacaoCarregamentoLista, RelatorioBaldeioLista, RelatorioInconsistenciasLista, RelatorioLotesItem, RelatorioLotesLista, RelatorioMILista, RetornoRetornarPendente, RomaneioClienteDto, RomaneioCompletoDto, RomaneioDto, RomaneioInfCertificado, RomaneioItem, RomaneioItemLista, RomaneioLista, RomaneioNF, RomaneioTransferenciaPedido, TransferenciaPedidoParaPedidoFiltro, TransferenciaPedidoParaPedidoLista, UR, URLista } from '../interface/romaneio';
import { IFiltroRomaneioLista } from '../filter/filtro-romaneio-lista';
import { IFiltroRomaneioClienteLista } from '../../expedicao/filter/filtro-romaneio-cliente-lista';
import { IFiltroDanosLista } from '../../expedicao/filter/filtro-controle-danos-lista';
import { IFiltroRelatorioBaldeio } from '../filter/filtro-relatorio-baldeio';
import { IFiltroRelatorioLotes } from '../filter/filtro-relatorio-lotes';
import { IFiltroControleQualidadeLista } from '../../expedicao/filter/filtro-controle-qualidade-lista';
import { ControleQualidadeCadastroItem, ControleQualidadeCadastroLista, ControleQualidadeLista } from '../../expedicao/interface/controle-qualidade';
import { IFiltroRelatorioMI } from '../filter/filtro-relatorio-mi';
import { PedidoDto } from 'src/app/faturamento/interface/pedido';
import { IFiltroCarregamentosME } from '../../expedicao/filter/filtro-carregamento-me';
import { IFiltroRelatorioLotesVsEstoque } from '../filter/filtro-relatorio-lotes-vs-estoque';


@Injectable({
  providedIn: 'root'
})
export class RomaneioService {

  constructor(
    private http: HttpClient,
    private utilService: UtilService) {
  }

  url = `${environment.urlApiProtheus}/wsrromaneio`;

  getLoadRomaneioRecimento(value: string): Observable<RomaneioDto> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.get<RomaneioDto>(`${this.url}/RomaneioRecebimento/${value}`,httpOptions);
  }

  getObjectByValue(value: string): Observable<RomaneioDto> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.get<RomaneioDto>(`${this.url}/${value}`,httpOptions);
  }

  getObjCompleto(value: string): Observable<RomaneioCompletoDto> {
    const httpOptions = this.utilService.filtrosHttpOptions({CCOMPLETO: 'S'});
    return this.http.get<RomaneioCompletoDto>(`${this.url}/${value}`,httpOptions);
  }

  lista(filtro: IFiltroRomaneioLista): Observable<RomaneioLista> {

    const httpOptions = this.utilService.filtrosHttpOptions(filtro);

    return this.http.get<RomaneioLista>(`${this.url}`, httpOptions);
  }

  listaRecebimento(filtro: IFiltroRomaneioLista): Observable<RomaneioLista> {

    const httpOptions = this.utilService.filtrosHttpOptions(filtro);

    return this.http.get<RomaneioLista>(`${this.url}/recebimento`, httpOptions);
  }

  listaDanos(filtro: IFiltroDanosLista): Observable<DanosLista> {

    const httpOptions = this.utilService.filtrosHttpOptions(filtro);

    return this.http.get<DanosLista>(`${this.url}/danos/lista`, httpOptions);
  }

  criarRegistro(dano: Dano): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/danos`, dano, httpOptions);
  }

  criarRomaneio(romaneio: CabecalhoRomaneio): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}`, romaneio, httpOptions);
  }

  excluirRomaneio(codigo: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.delete(`${this.url}/${codigo}`, httpOptions);
  }

  retornarPendente(codigo: string): Observable<RetornoRetornarPendente> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post<RetornoRetornarPendente>(`${this.url}/retornar-pendente/${codigo}`, httpOptions);
  }


  forcaRetornarPendente(codigo: string): Observable<RetornoRetornarPendente> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post<RetornoRetornarPendente>(`${this.url}/forca-retornar-pendente/${codigo}`, httpOptions);
  }

  valorTotalRomaneio(pedido: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.get(`${this.url}/valor-total/${pedido}`, httpOptions);
  }

  excluirDano(codigo: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.delete(`${this.url}/dano/${codigo}`)
  }

  dataRetorno(dano: Dano): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/retorno/dano/`, dano, httpOptions)
  }

  postEnvLotDano(dano: Dano): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/envlote/dano/`, dano, httpOptions)
  }

  biparEtiqueta(codigoRomaneio: string, etiqueta: string): Observable<RomaneioItem> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post<RomaneioItem>(`${this.url}/item/${codigoRomaneio}/${etiqueta}`, {}, httpOptions);
  }

  confirmarRecebimentoEtiqueta(item: ExpedicaoRomaneioItemDto): Observable<ExpedicaoRomaneioItemDto> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post<ExpedicaoRomaneioItemDto>(`${this.url}/recebimento/confirmar`, item, httpOptions);
  }

  removerEtiqueta(codigo: string, etiqueta: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.delete(`${this.url}/${codigo}/${etiqueta}`, httpOptions);
  }

  removerEtiquetaRecebimento(codigo: string, etiqueta: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.delete(`${this.url}/recebimento/${codigo}/${etiqueta}`, httpOptions);
  }

  avancarRomaneio(codigo: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/avancar/${codigo}`, {}, httpOptions);
  }

  atualizarStatusRomaneioCliente(romaneioCliente: RomaneioClienteDto): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/cliente/atualizar-status/${romaneioCliente.CZ00COD}`, romaneioCliente, httpOptions);
  }

  finalizarRomaneio(codigo: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/finalizar/${codigo}`, {}, httpOptions);
  }

  consultaTransferenciaExpedicao(codigo: string): Observable<ExpedicaoRomaneioItemPedidoDto> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.get<ExpedicaoRomaneioItemPedidoDto>(`${this.url}/expedicao/consulta-transferencia/${codigo}`, httpOptions);
  }

  transferenciaPedido(codigoEtiqueta: string, codigoPedido: string, CCONFIRMA: string = ''): Observable<RomaneioTransferenciaPedido> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post<RomaneioTransferenciaPedido>(`${this.url}/expedicao/transferencia-pedido/${codigoEtiqueta}/${codigoPedido}`, { CCONFIRMA }, httpOptions);
  }

  alterarContainer(CZ02COD: string, NZ02CTNR: number): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/expedicao/altera-container/${CZ02COD}/${NZ02CTNR}`, {}, httpOptions);
  }

  alterarUR(CZ02COD: string, CZ02UR: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/expedicao/altera-ur/${CZ02COD}/${CZ02UR}`, {}, httpOptions);
  }

  consultaLote(codigo: string): Observable<Dano> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.get<Dano>(`${this.url}/danos/cadastro/${codigo}`, httpOptions);
  }

  consultaLote2(codigo: string): Observable<Dano> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.get<Dano>(`${this.url}/danos/cadastro/${codigo}`, httpOptions);
  }

  listaPedidosCliente(codigoCliente: string): Observable<PedidoItemExpedicaoDtoLista> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.get<PedidoItemExpedicaoDtoLista>(`${this.url}/expedicao/lista-pedidos/${codigoCliente}`, httpOptions);
  }

  liberarPedidos(pedido: PedidoDto, CZ00COD: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/expedicao/liberar-pedidos/${CZ00COD}`, pedido, httpOptions);
  }

  listaRomaneioCliente(filtro: IFiltroRomaneioClienteLista): Observable<RomaneioLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.http.get<RomaneioLista>(`${this.url}/cliente/lista`, httpOptions);
  }

  listaRomaneioMI(filtro: IFiltroRomaneioClienteLista): Observable<RomaneioLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.http.get<RomaneioLista>(`${this.url}/mercado-interno/lista`, httpOptions);
  }

  criarRomaneioCliente(romaneio: CabecalhoRomaneioCliente): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/cliente`, romaneio, httpOptions);
  }

  criarRomaneioClienteMI(romaneio: CabecalhoRomaneioCliente): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/mercado-interno`, romaneio, httpOptions);
  }

  getRomaneioCliente(codigo: string): Observable<RomaneioClienteDto> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.get<RomaneioClienteDto>(`${this.url}/cliente/${codigo}`, httpOptions);
  }

  getRomaneioClienteShort(codigo: string): Observable<RomaneioClienteDto> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.get<RomaneioClienteDto>(`${this.url}/cliente/short/${codigo}`, httpOptions);
  }

  getPdfRomaneio(CZ00COD: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    httpOptions.responseType = 'blob' as 'json';
    return this.http.get<any>(`${this.url}/pdf-romaneio/${CZ00COD}`, httpOptions);
  }

  getEtiquetaCliente(CZ01ETIQ: string, CIMPRESSORA: string, NCOPIAS: string, CINSTRUCAO: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    httpOptions.responseType = 'blob' as 'json';
    httpOptions.headers = new HttpHeaders({
      'X-PO-Screen-Lock': 'true',
      'Accept-Language': 'pt-BR',
    })
    return this.http.get<any>(`${this.url}/etiqueta-cliente/${CZ01ETIQ}/${CIMPRESSORA}/${NCOPIAS}/${CINSTRUCAO}`, httpOptions);
  }

  alterarDadosRomaneioCliente(dados: RomaneioClienteDto): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/cliente/alterar-dados`, dados, httpOptions);
  }

  adicionarItensRomaneioCliente(codigoRomaneio: string, pedidoLote: PedidoLote): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/cliente/item/${codigoRomaneio}`, pedidoLote, httpOptions);
  }

  pesar(): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.get<any>(`${this.url}/balanca/pesar`, httpOptions);
  }

  getEtiquetaDano(CZ03COD: string, CZ03LOTE: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    httpOptions.responseType = 'blob' as 'json';

    return this.http.get<any>(`${this.url}/etiqueta-dano/${CZ03COD}/${CZ03LOTE}`, httpOptions);
  }

  listaRelatorioBaldeio(filtro: IFiltroRelatorioBaldeio): Observable<RelatorioBaldeioLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.http.get<RelatorioBaldeioLista>(`${this.url}/relatorio/baldeio`, httpOptions);
  }

  listaRelatorioMI(filtro: IFiltroRelatorioMI): Observable<RelatorioMILista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.http.get<RelatorioMILista>(`${this.url}/mercado-interno/relatorio`, httpOptions);
  }

  listaRelatorioInconsistencias(): Observable<RelatorioInconsistenciasLista> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.get<RelatorioInconsistenciasLista>(`${this.url}/relatorio/incosistencias`, httpOptions);
  }

  listaRelatorioLotes(filtro: IFiltroRelatorioLotes): Observable<RelatorioLotesLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.http.get<RelatorioLotesLista>(`${this.url}/relatorio/lotes`, httpOptions);
  }

  consultaPedidoTransferencia(filtro: TransferenciaPedidoParaPedidoFiltro): Observable<RomaneioItemLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.http.get<RomaneioItemLista>(`${this.url}/expedicao/consulta-pedido-transferencia`, httpOptions);
  }

  transferenciaArmazemPedido(CZ02PEDIDO: string, motivo: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post<any>(`${this.url}/expedicao/transferencia-armazem/pedido/${CZ02PEDIDO}`, {'CMOTIVO': motivo}, httpOptions);
  }

  transferenciaArmazemLote(lote: string, motivo: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post<any>(`${this.url}/expedicao/transferencia-armazem/lote/${lote}`, {'CMOTIVO': motivo}, httpOptions);
  }

  transferenciaArmazem98(CZ02COD: string, confirma: boolean = false): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post<any>(`${this.url}/expedicao/transferencia-armazem/98/${CZ02COD}`, {'CONFIRMA': confirma ? 'S' : 'N'}, httpOptions);
  }

  transferenciaPedidoCompleto(CZ02PEDIDO: string, CC5NUM: string): Observable<TransferenciaPedidoParaPedidoLista> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post<TransferenciaPedidoParaPedidoLista>(`${this.url}/expedicao/transferencia-pedido-completo/${CZ02PEDIDO}/${CC5NUM}`, {}, httpOptions);
  }

  transferenciaPedidoItens(CZ02PEDIDO: string, CPEDIDO: string, CTIPO: string, items: RomaneioItemLista): Observable<TransferenciaPedidoParaPedidoLista> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post<TransferenciaPedidoParaPedidoLista>(`${this.url}/expedicao/transferencia-pedido-itens/${CZ02PEDIDO}/${CTIPO}/${CPEDIDO}`, items, httpOptions);
  }

  postGerarPedidoMI(romaneioCliente: RomaneioClienteDto): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post<any>(`${this.url}/mercado-interno/gerar-pedido`, romaneioCliente, httpOptions);
  }

  getDadosEtiquetaControleQualidade(etiqueta: string): Observable<ControleQualidadeCadastroItem> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.get<ControleQualidadeCadastroItem>(`${this.url}/controle-qualidade/lote/${etiqueta}`, httpOptions);
  }

  postControleQualidade(controleQualidade: ControleQualidadeCadastroLista): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post<any>(`${this.url}/controle-qualidade`, controleQualidade, httpOptions);
  }

  getEtiquetaControleQualidade(tipo: 'C' | 'L', chave: string, impressora: string, copias: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    httpOptions.responseType = 'blob' as 'json';
    httpOptions.headers = new HttpHeaders({
      'X-PO-Screen-Lock': 'true',
      'Accept-Language': 'pt-BR',
    });
    return this.http.get<any>(`${this.url}/controle-qualidade/etiqueta/${tipo}/${chave}/${impressora}/${copias}`, httpOptions);
  }

  putControleQualidade(codigo: string, motivo: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.put<any>(`${this.url}/controle-qualidade/${codigo}/${motivo}`, {}, httpOptions);
  }

  getControleQualidadeLista(filtro: IFiltroControleQualidadeLista): Observable<ControleQualidadeLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.http.get<ControleQualidadeLista>(`${this.url}/controle-qualidade/lista`, httpOptions);
  }

  deleteItemControleQualidade(CZ04CODIGO: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.delete(`${this.url}/controle-qualidade/${CZ04CODIGO}`, httpOptions);
  }

  postEnviaPDFRomaneioTransportadora(CZ00COD: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/romaneio-cliente/enviarPDFRomaneio/${CZ00COD}`, {}, httpOptions);
  }

  getURLista(filtro: FiltroUR): Observable<URLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.http.get<URLista>(`${this.url}/UR/lista`, httpOptions);
  }

  postUR(dados: UR): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/UR/incluir`, dados, httpOptions);
  }

  deleteUR(recno: number): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.delete(`${this.url}/UR/deletar/${recno}`, httpOptions);
  }

  getURListaCombo(produto: string): Observable<URLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(produto);
    return this.http.get<URLista>(`${this.url}/UR/listaCombo/${produto}`, httpOptions);
  }

  postAlterarUR(CZ02COD:string,CZ02UR:string ,CZ02LOTE:string, CB1COD:string, NZ05RECNO:number): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/UR/alteraur/${CZ02COD}/${CZ02UR}/${CZ02LOTE}/${CB1COD}/${NZ05RECNO}`, {}, httpOptions);
  }

  postControleCarregamento(romaneio: CabecalhoRomaneio): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/controle-carregamento`, romaneio, httpOptions);
  }

  postValidaAcessoCarregamentoRomaneio(senha: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post<any>(`${this.url}/cliente/lista/valida-acesso`, {senha: senha} ,httpOptions);
  }

  postInformacaoCertificadoRomaneio(dados: RomaneioInfCertificado): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.http.post(`${this.url}/informacao-certificado`, dados, httpOptions);
  }

  getPdfCertificados(CZ00COD: string, NQTDUR: number): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    httpOptions.responseType = 'blob' as 'json';
    return this.http.get<any>(`${this.url}/pdf-certificados/${CZ00COD}/${NQTDUR}`, httpOptions);
  }

  getCarregamentosMELista(filtro: IFiltroCarregamentosME): Observable<ProgramacaoCarregamentoItems> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.http.get<ProgramacaoCarregamentoItems>(`${this.url}/carregamentos-me/lista`, httpOptions);
  }

  getCarregamentosMEListaComboBox(): Observable<ProgramacaoCarregamentoItems> {
    const httpOptions = this.utilService.filtrosHttpOptions()
    return this.http.get<ProgramacaoCarregamentoItems>(`${this.url}/carregamentos-me/listacombo`,httpOptions);
  }

  postCarregamentosME(dados: ProgramacaoCarregamentoLista): Observable<ProgramacaoCarregamentoLista> {
    const httpOptions = {
      headers: new HttpHeaders({'X-PO-Screen-Lock': 'true'})
    };
    return this.http.post<ProgramacaoCarregamentoLista>(`${this.url}/carregamentos-me`,dados,httpOptions);
  }

  emailCarregamentoTransportadoras(CZ07CODIGO: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({'X-PO-Screen-Lock': 'true'})
    };
    return this.http.post<any>(`${this.url}/carregamentos-me/envia-email/${CZ07CODIGO}`,httpOptions);
  }

  postRetornarPendenteCarregamentoME(NZ07RECNO: number): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({'X-PO-Screen-Lock': 'true'})
    };
    return this.http.post<any>(`${this.url}/carregamentos-me/retornar-pendente/${NZ07RECNO}`,httpOptions);
  }

  postProgramacaoCarregamento(romaneios: string, carregamento: string, operacao: string, data: Date | undefined, hora: string): Observable<CabecalhoRomaneio> {
    const httpOptions = {
      headers: new HttpHeaders({'X-PO-Screen-Lock': 'true'})
    };
    return this.http.post<CabecalhoRomaneio>(`${this.url}/programacao-carregamento`,{CROMANEIO: romaneios, CCARREGAMENTO: carregamento, COPERACAO: operacao, DDATA: data, CHORA: hora},httpOptions);
  }

  getNFEntrada(CFORNECE: string, CLOJA: string, CDOC: string, CSERIE: string): Observable<RomaneioNF> {
    const httpOptions = {
      headers: new HttpHeaders({'X-PO-Screen-Lock': 'true'})
    };
    return this.http.get<RomaneioNF>(`${this.url}/nf-entrada/${CDOC}/${CSERIE}/${CFORNECE}/${CLOJA}`,httpOptions);
  }

  postGerarRomaneioNFE(romaneioNF: RomaneioNF): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({'X-PO-Screen-Lock': 'true'})
    };
    return this.http.post<any>(`${this.url}/nf-entrada/gerar-romaneio/${romaneioNF.CF1DOC}/${romaneioNF.CF1SERIE}/${romaneioNF.CF1FORNECE}/${romaneioNF.CF1LOJA}`,{},httpOptions);
  }

  listaRelatorioLotesVsEstoque(filtro: IFiltroRelatorioLotesVsEstoque): Observable<RomaneioNF> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.http.get<RomaneioNF>(`${this.url}/relatorio/lotes-vs-estoque`,httpOptions);
  }

}
